export const SOURCE_QUERY_PARAM = 'source';
export const REDIRECT_QUERY_PARAM = 'redirect';
export const AUTOLOGIN_ENCODED_MSISDN_QUERY_PARAM = 'm';
export const AUTOLOGIN_ENCODED_ID_QUERY_PARAM = 'i';

export const LOCALE_HEADER = 'X-Locale';
export const LOYALTY_CLUB_SLUG_HEADER = 'X-Loyalty-Club-Slug';

export const LOYALTY_CLUB_METADATA_SELECTOR = 'name=\'loyalty-club-slug\'';
